<template>
  <v-container>
    <PageHeader :subtitle="subTitle" />
    <v-progress-linear indeterminate v-if="isLoading"></v-progress-linear>

    <v-layout v-if="!isLoading && hasData" elevation="0" row wrap>
      <v-flex xs12 sm6 pa-1>
        <Subheader title="Metadata" />
        <v-card elevation="0">
          <v-card-text>
            <KVStoreTable :value="specimen.Metadata" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 pa-1>
        <Subheader title="Surveys" />
        <v-card elevation="0">
          <v-card-text>
            <v-list three-line>
              <template v-for="(survey, i) in specimen.Surveys">
                <v-divider v-if="i != 0" :key="`divider-${survey.Id}`" />
                <PlotSurveyHeader :value="survey" :key="survey.ParentSurveyId" />
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 v-for="survey in specimen.Surveys" :key="`survey-data-${survey.Id}`">
        <Subheader :title="`Specimen survey ${specimen.SpeciesCode} ${survey.SurveyDateTimeRaw}`" />
        <v-card elevation="0">
          <v-card-text>
            <KVStoreTable :value="survey.Metadata" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import PlotSurveyHeader from '@/components/vegetativemonitoring/Header/PlotSurveyHeader'
  export default {
    components: {
      PlotSurveyHeader,
    },
    props: {
      specimenId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        isLoading: false,
        specimen: {},
      }
    },
    computed: {
      hasData() {
        return this.specimen.Id != null
      },
      subTitle() {
        if (this.specimen == null || this.specimen == {}) {
          return ''
        }
        let latinName = this.specimen.SpeciesFullLatinName
        let commonName = this.specimen.SpeciesCommonName
        if (latinName != null && commonName != null) {
          return `${commonName} (${latinName})`
        }
        return commonName || latinName || ''
      },
    },
    methods: {
      async getSpecimenDetail() {
        try {
          this.isLoading = true
          let res = await this.axios.get(`api/vegetativemonitoring/specimen/${this.specimenId}`)
          this.specimen = res.data
        } catch (error) {
          console.error(error)
        } finally {
          this.isLoading = false
        }
      },
    },
    created() {
      this.getSpecimenDetail()
    },
  }
</script>